import { useMemo, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { FreeMode, Keyboard, Navigation, Thumbs } from "swiper";
import { Button } from "components";

import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";

import "./ThumbSlider.scss";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

interface ThumbSliderProps {
  sliderData: JSX.Element[] | string[];
}

export const ThumbSlider = ({ sliderData }: ThumbSliderProps) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperCore | null>(null);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const nextRef = useRef<HTMLButtonElement>(null);
  const prevRef = useRef<HTMLButtonElement>(null);

  const sliderProgress = useMemo(() => {
    if (activeIndex === 0) {
      return (1 / sliderData?.length) * 100;
    } else {
      return (
        (activeIndex / sliderData?.length) * 100 +
        (1 / sliderData?.length) * 100
      );
    }
  }, [activeIndex, sliderData?.length]);

  return (
    <>
      {sliderData?.length > 0 && (
        <div className="thumb-slider-container">
          <Swiper
            rewind={true}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
              enabled: true,
            }}
            onSlideChange={(swiper) => {
              setActiveIndex(swiper?.activeIndex);
            }}
            thumbs={{ swiper: thumbsSwiper }}
            modules={[FreeMode, Navigation, Thumbs, Keyboard]}
            className="swiper-1"
            keyboard={{
              enabled: true,
            }}
          >
            {sliderData?.map((data) => (
              <SwiperSlide key={Math.random()}>{data}</SwiperSlide>
            ))}
            <Button.RoundedButton ref={prevRef} className="swiper-button-prev swiper-button-custom">
              <MdOutlineKeyboardArrowLeft />
            </Button.RoundedButton>
            <Button.RoundedButton ref={nextRef} className="swiper-button-next swiper-button-custom">
              <MdOutlineKeyboardArrowRight />
            </Button.RoundedButton>
          </Swiper>
          <Swiper
            onSwiper={setThumbsSwiper}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
              enabled: true,
            }}
            slidesPerView={4}
            watchSlidesProgress={true}
            modules={[FreeMode, Navigation, Thumbs]}
            className="swiper-2"
          >
            {sliderData?.map((data) => (
              <SwiperSlide key={Math.random()}>{data}</SwiperSlide>
            ))}
          </Swiper>
          <div className="thumb-slider__actions">
            <div className="thumb-slider__actions-indicator-track">
              <div
                className="thumb-slider__actions-indicator"
                style={{ width: `${sliderProgress}%` }}
              ></div>
            </div>
            {/* <div className="thumb-slider__actions-buttons">
              <Button.RoundedButton ref={prevRef}>
                <MdOutlineKeyboardArrowLeft />
              </Button.RoundedButton>
              <Button.RoundedButton ref={nextRef}>
                <MdOutlineKeyboardArrowRight />
              </Button.RoundedButton>
            </div> */}
          </div>
        </div>
      )}
    </>
  );
};
